import React from "react";
import { Avatar, IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { dash } from "./dashboard/dashboardTokens";

export default function TopBarProfileAvatar({ account, onClick }) {
  const firstInitial = account?.getFirstName?.()?.charAt(0)?.toUpperCase();
  const lastInitial = account?.getLastName?.()?.charAt(0)?.toUpperCase();
  const initials = firstInitial
    ? `${firstInitial}${lastInitial || ""}`
    : null;

  return (
    <IconButton
      onClick={onClick}
      aria-label="Open profile"
      size="small"
      sx={{
        p: 0.25,
        borderRadius: "50%",
        transition: `box-shadow ${dash.transition}, transform ${dash.transition}`,
        "&:hover": {
          transform: "scale(1.04)",
        },
        "&:focus-visible": {
          outline: `2px solid ${dash.accent}`,
          outlineOffset: 2,
        },
      }}
    >
      <Avatar
        sx={{
          width: 32,
          height: 32,
          bgcolor: "#1F456E",
          color: "#ffffff",
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        {initials || <PersonIcon sx={{ fontSize: 18 }} />}
      </Avatar>
    </IconButton>
  );
}
